import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { Link, useNavigate } from "react-router-dom";
import { GlobalDataContext } from "contexts/GlobalData";
import MePersonalInfo from "./MePersonalInfo";
import MeProfile from "./MeProfile";
import MeHead from "./MeHead";
import SigninForm from "components_custom/SigninForm/SigninForm";
import { requestAPI } from "utils/api";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const Me: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {
	const navigate = useNavigate ();	
	const { 
		initData,
	} = useContext (GlobalDataContext);

	const [userData, setUserData] = useState <any>({});

	useEffect(()=>{
		if (initData.token_info.permission_group !== "guest") {
			(async () => {
				const res: any = await requestAPI ('GET', 'v1/user/me', {});		
				console.log("r3", res);
				setUserData(res.data.userInfo)
			})()
		}
		
	}, []);

	const handleClick = async () => {
		const res_token: any = await requestAPI ('DELETE', 'token', {});
		
		
		console.log("token get? ", res_token);
		// console.log(res_init);

		//let localData = localStorage.getItem('authInfo');
		navigate(0);
		
			
	}

	console.log(initData.token_info.permission_group);

	// 아래를 설정하면 guest에서 안나옴
	if (Object.keys(userData).length === 0 && initData.token_info.permission_group !== "guest") return (<></>)

	return (
		<>	
			{(initData.token_info.permission_group === "guest")
			?
				<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
					<div className="flex flex-col lg:flex-row">
						<div className="w-full pl-[1rem] pr-[1rem]">
							<div className="mt-5" />
							<MeHead />
							<div className="max-w-md mx-auto space-y-6 mt-[100px]">
								<SigninForm />
							</div>
						
					
							<div className="mt-[100px]" />
							<FooterNav />
						</div>
					</div>
				</div>
			:
				<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-full bg-white !p-0 lg:w-[768px]`}>

					<div className="flex flex-col lg:flex-row">
						<div className="w-full pl-[1rem] pr-[1rem]">
							<div className="mt-5" />
							<MeHead />
							<MeProfile userData={userData} />
							<MePersonalInfo 
								userData={userData}
							/>
							
							<div className="mt-10 text-right">
								<button onClick={() => handleClick()}>로그아웃</button>
							</div>

							<div className="mt-[100px]" />
							<FooterNav />
						</div>
					</div>
				</div>
			}		
		</>
	);
};

export default Me;
